module.exports = __webpack_public_path__ + "fonts/Cabin-SemiBold.c17cf22.ttf";